import { StrictMode } from 'react';

import ReactDOM from 'react-dom/client';

import { init } from '@repo/api/client';

import env from '~/env';
import App from './App.tsx';

const API_URL = env.VITE_API_URL;

init(API_URL);

async function enableMocking() {
	// use the full import.meta object here so
	// vite can notice and not import msw in production
	if (import.meta.env.VITE_USE_MOCKS !== 'true') {
		return;
	}

	const { worker } = await import('./msw/browser');

	// `worker.start()` returns a Promise that resolves
	// once the Service Worker is up and ready to intercept requests.
	return worker.start({
		serviceWorker: {
			url: '/sw-msw.js',
		},
		// This prevents lots of MSW unhandled request warnings in the browser console
		// This will only log an unhandled request if it is an endpoint that starts with the API base URL
		// This should mean that only meaningful warnings that actually require changes are displayed by MSW
		onUnhandledRequest: (req, print) => {
			if (!req.url.startsWith(API_URL)) return;
			print.warning();
		},
	});
}

const rootElement = document.getElementById('app')!;

if (!rootElement.innerHTML) {
	void enableMocking().then(() => {
		ReactDOM.createRoot(rootElement).render(
			<StrictMode>
				<App />
			</StrictMode>,
		);
	});
}
